module.exports = __webpack_public_path__ + "img/legend-last.e72b44fa.svg";